import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Calendar } from "lucide-react";
import { LEGAL_ENTITY, CONTACT_EMAIL } from "../../config/siteConfig";

// Founder trust block — real person, real story, no outcome claims
export const FounderBlock = () => (
  <section id="founder" className="py-16 bg-gradient-to-b from-transparent to-slate-900/40">
    <div className="mx-auto max-w-5xl px-6">
      <div className="grid md:grid-cols-5 gap-8 items-center">
        <div className="md:col-span-2">
          <div className="aspect-square rounded-3xl bg-gradient-to-br from-blue-500/20 via-cyan-500/10 to-transparent border border-white/10 overflow-hidden flex items-center justify-center relative">
            {/* Initials placeholder until a real photo is added */}
            <div className="text-7xl font-bold bg-clip-text text-transparent bg-gradient-to-br from-blue-400 to-cyan-300 select-none">
              MB
            </div>
            <div className="absolute bottom-4 left-4 right-4 rounded-xl bg-slate-950/80 backdrop-blur border border-white/10 px-3 py-2">
              <p className="text-xs text-slate-400 uppercase tracking-wider">Founder</p>
              <p className="text-sm font-semibold text-white">Mark Becker</p>
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs text-slate-400 uppercase tracking-wide mb-4">
            Meet the team
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Built by someone who&rsquo;s been there.
          </h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Hi, I&rsquo;m <strong className="text-white">Mark Becker</strong>, the founder of Social Dispute Co.
              I started this service after seeing how much the appeal process can feel like shouting into a void —
              generic forms, no response for weeks, and a lot of people left without a livelihood when their account went down.
            </p>
            <p>
              We don&rsquo;t promise miracles, and we don&rsquo;t pretend to have special access. What we do is prepare
              organized, professional documentation that addresses the specific policy each platform cites,
              then submit through the same public appeal channels anyone can use — just done properly.
            </p>
            <p className="text-sm text-slate-400 italic">
              We&rsquo;re an 8eight8 LLC registered business in Hawaii with a published refund policy,
              transparent pricing, and zero guarantees. If that sounds like the right fit, we&rsquo;re here.
            </p>
          </div>

          <div className="mt-6 grid sm:grid-cols-3 gap-3 text-sm">
            <div className="flex items-center gap-2 text-slate-400">
              <Calendar className="w-4 h-4 text-blue-400" />
              <span>Founded 2024</span>
            </div>
            <div className="flex items-center gap-2 text-slate-400">
              <MapPin className="w-4 h-4 text-blue-400" />
              <span>{LEGAL_ENTITY.city}, {LEGAL_ENTITY.state}</span>
            </div>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="flex items-center gap-2 text-slate-300 hover:text-white transition"
              data-testid="founder-email-link"
            >
              <Mail className="w-4 h-4 text-blue-400" />
              <span>Contact Mark</span>
            </a>
          </div>

          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/5 border border-white/10 text-sm font-medium text-white hover:bg-white/10 transition"
              data-testid="founder-about-link"
            >
              Read our full story
            </Link>
            <Link
              to="/trust"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/5 border border-white/10 text-sm font-medium text-white hover:bg-white/10 transition"
              data-testid="founder-trust-link"
            >
              Verify our business
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);
